import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { message, Spin } from 'antd';

import AnswerList from './answer-list';
import QuestionList from './question-list';
import ProcessInfo from './process-info';
import { getExamPaper } from '../api';
import { QuestionListItem, TestInfo } from '../types';

import './index.less';

function OnlineTest() {
  const [testInfo, setTestInfo] = useState<TestInfo>({
    curTime: 0,
    startTime: 0,
    time: 0,
    name: '',
    mark: 0
  });
  const [isSpinning, setIsSpinning] = useState(true);
  const [questionList, setQuestionList] = useState<QuestionListItem[]>([]);
  const [textFontSize, setTextFontSize] = useState(14);
  const urlParams: { id: string } = useParams();
  const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify({})) || {};

  useEffect(() => {
    setIsSpinning(true);
    getExamPaper({ examID: urlParams.id, user_id: userinfo.id }).then((res: any) => {
      setIsSpinning(false);
      if (res && res.code === 0) {
        const { paper, curTime, startTime, time, name, mark } = res.data;
        setQuestionList(paper);
        setTestInfo({ name, curTime, startTime, time, mark });
      } else {
        res && message.error(res.msg || '获取失败！');
      }
    })
  }, [urlParams.id])

  // if (questionList.length === 0 || testInfo.time === 0) {
  //   return null;
  // }

  return (
    <Spin tip="加载中..." spinning={isSpinning}>
      <div className="online-test">
        <div className="online-test-head">
          <div className="head">
            <div className="head-left">{testInfo.name}</div>
            <div className="head-right">{userinfo.employee_name}</div>
          </div>
        </div>
        <div className="online-test-content">
          <div className="content">
            <AnswerList questionList={questionList} />
            <QuestionList textFontSize={textFontSize} questionList={questionList} setQuestionList={setQuestionList} />
            <ProcessInfo
              testInfo={testInfo}
              questionList={questionList}
              textFontSize={textFontSize}
              setTextFontSize={setTextFontSize}
            />
          </div>
        </div>
      </div>
    </Spin>
  )
}

export default OnlineTest;
